import { lazy } from "solid-js";

import { isMobile } from "@/lib/isMobile";

export default function Casinopage() {
  const Casino = lazy(() =>
    isMobile() ? import("@/pages/h5/casino") : import("@/pages/pc/casino"),
  );
  return <Casino />;
}
